<script>
import BaseForm from '@/components/base/BaseForm.vue';

/**
 * Попап-обёртка вокруг BaseForm. Открывается через popupModel.add():
 *
 *   const values = await popupModel.add({
 *     wrappable: true,
 *     component: BaseFormPopupWrappable,
 *     params: { title: 'Задача', fields, values },
 *   });
 *
 * Резолвится значениями формы или false, если её закрыли.
 */
export default {
  name: 'BaseFormPopupWrappable',
  components: { BaseForm },
  data() {
    return {
      title: '',
      fields: {},
      values: {},
      submitText: 'Сохранить',
    };
  },
  methods: {
    init(params = {}) {
      this.title = params.title ?? '';
      this.fields = params.fields ?? {};
      this.values = params.values ?? {};
      this.submitText = params.submitText ?? 'Сохранить';
    },
  },
};
</script>

<template lang="pug">
  .b-base-form-popup
    BaseForm(
      :title="title"
      :fields="fields"
      :values="values"
      :submitText="submitText"
      @submit="$emit('finish', $event)"
      @cancel="$emit('finish', false)"
    )
</template>

<style scoped lang="scss">
// Своих отступов не добавляем: их даёт BasePopup, а поля формы должны
// занимать всю ширину попапа
.base-form-popup {
  width: 520px;
  max-width: 100%;
  box-sizing: border-box;
}
</style>
